import {
  erpPageBreadcrumbClass,
  erpPageBreadcrumbCurrentClass,
  erpPageBreadcrumbItemClass,
  erpPageBreadcrumbSepClass,
} from '@euroasiann/shared/ui';

export function PrivacyPolicyPage() {
  return (
    <div className="w-full space-y-6">
      <div>
        <nav className={`${erpPageBreadcrumbClass} mb-2`} aria-label="Breadcrumb">
          <span className={erpPageBreadcrumbItemClass}>Legal</span>
          <span className={erpPageBreadcrumbSepClass}>/</span>
          <span className={erpPageBreadcrumbCurrentClass}>Privacy Policy</span>
        </nav>
        <h1 className="text-3xl font-bold text-[hsl(var(--foreground))]">Privacy Policy</h1>
      </div>
      <div className="bg-[hsl(var(--card))] rounded-xl p-8 border border-[hsl(var(--border))] space-y-4 text-[hsl(var(--foreground))]">
        <p className="text-[hsl(var(--muted-foreground))] leading-relaxed">
          Euroasiann respects your privacy. This policy describes how we collect, use, and protect
          information when you use the Tech Portal.
        </p>
        <section className="space-y-2">
          <h2 className="text-lg font-semibold">Information We Collect</h2>
          <p className="text-sm text-[hsl(var(--muted-foreground))] leading-relaxed">
            We process staff account details, audit logs, organization and license records, onboarding
            data, and support interactions necessary to operate the platform.
          </p>
        </section>
        <section className="space-y-2">
          <h2 className="text-lg font-semibold">How We Use Information</h2>
          <p className="text-sm text-[hsl(var(--muted-foreground))] leading-relaxed">
            Data is used to provide ERP services, improve reliability, enforce security, and comply
            with legal obligations. We do not sell personal data to third parties.
          </p>
        </section>
        <section className="space-y-2">
          <h2 className="text-lg font-semibold">Data Retention & Security</h2>
          <p className="text-sm text-[hsl(var(--muted-foreground))] leading-relaxed">
            Records are retained according to platform policy and regulatory requirements. Access
            controls, encryption in transit, and audit logging help protect sensitive information.
          </p>
        </section>
        <section className="space-y-2">
          <h2 className="text-lg font-semibold">Your Rights</h2>
          <p className="text-sm text-[hsl(var(--muted-foreground))] leading-relaxed">
            Staff may request data export, correction, or deletion subject to contractual and legal
            constraints. Contact platform support for assistance.
          </p>
        </section>
      </div>
    </div>
  );
}
